import {
  TemplateParentTypeEnum,
  WidgetTypeConfig,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import {
  isDisplayTemplate,
  isEmailTemplate,
} from '../../utils/helpers';
// eslint-disable-next-line import/no-cycle
import displayWidgetCountdownConfigV4 from '@/components/template-builder/config/templates/display-v4/widgets/widget-countdown-config';
// eslint-disable-next-line import/no-cycle
import emailWidgetCountdownConfig from '@/components/template-builder/config/templates/email-v4/widgets/widget-countdown-config';

const getWidgetCountdownConfig = (templateType: TemplateParentTypeEnum): WidgetTypeConfig => {
  // Email countdown (GIF-based)
  if (isEmailTemplate(templateType)) {
    return emailWidgetCountdownConfig;
  }

  // Display countdown (JS-based)
  if (isDisplayTemplate(templateType)) {
    return displayWidgetCountdownConfigV4;
  }

  return { tabPanel: { label: '', items: [] } };
};

export default getWidgetCountdownConfig;
